/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddPermissionDto } from '../models/work-add-permission-dto';
import { WorkAddUserDto } from '../models/work-add-user-dto';
import { WorkCreateRoletypeDto } from '../models/work-create-roletype-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRemovePermissionDto } from '../models/work-remove-permission-dto';
import { WorkRemoveUserDto } from '../models/work-remove-user-dto';
import { WorkRoletype } from '../models/work-roletype';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateRoletypeDto } from '../models/work-update-roletype-dto';

@Injectable({ providedIn: 'root' })
export class WorkRoletypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `roletypesV2ControllerGetAllDropdownOptions()` */
  static readonly RoletypesV2ControllerGetAllDropdownOptionsPath = '/v2/roletypes/dropdown-options';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.roletypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerGetForNewEmployeeSelection()` */
  static readonly RoletypesV2ControllerGetForNewEmployeeSelectionPath = '/v2/roletypes/for-new-employee-selection';

  /**
   * Required permissions: users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerGetForNewEmployeeSelection()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerGetForNewEmployeeSelection$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkRoletype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerGetForNewEmployeeSelectionPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkRoletype>>;
      })
    );
  }

  /**
   * Required permissions: users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerGetForNewEmployeeSelection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerGetForNewEmployeeSelection(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkRoletype>> {
    return this.roletypesV2ControllerGetForNewEmployeeSelection$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkRoletype>>): Array<WorkRoletype> => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerFindAllPaginated()` */
  static readonly RoletypesV2ControllerFindAllPaginatedPath = '/v2/roletypes';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>label</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'label:ASC' | 'label:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,label
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>label</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkRoletype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkRoletype>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>label</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'label:ASC' | 'label:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,label
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>label</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkRoletype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.roletypesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkRoletype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkRoletype>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerCreate()` */
  static readonly RoletypesV2ControllerCreatePath = '/v2/roletypes';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerCreate$Response(
    params: {
      body: WorkCreateRoletypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerCreate(
    params: {
      body: WorkCreateRoletypeDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.roletypesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerFindOneById()` */
  static readonly RoletypesV2ControllerFindOneByIdPath = '/v2/roletypes/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkRoletype>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkRoletype>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkRoletype> {
    return this.roletypesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkRoletype>): WorkRoletype => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerDelete()` */
  static readonly RoletypesV2ControllerDeletePath = '/v2/roletypes/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.roletypesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerUpdate()` */
  static readonly RoletypesV2ControllerUpdatePath = '/v2/roletypes/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateRoletypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateRoletypeDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.roletypesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerAddUserToRoletype()` */
  static readonly RoletypesV2ControllerAddUserToRoletypePath = '/v2/roletypes/{id}/users';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerAddUserToRoletype()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerAddUserToRoletype$Response(
    params: {
      id: number;
      body: WorkAddUserDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerAddUserToRoletypePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerAddUserToRoletype$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerAddUserToRoletype(
    params: {
      id: number;
      body: WorkAddUserDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.roletypesV2ControllerAddUserToRoletype$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerRemoveUserFromRoletype()` */
  static readonly RoletypesV2ControllerRemoveUserFromRoletypePath = '/v2/roletypes/{id}/users';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerRemoveUserFromRoletype()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerRemoveUserFromRoletype$Response(
    params: {
      id: number;
      body: WorkRemoveUserDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerRemoveUserFromRoletypePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerRemoveUserFromRoletype$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerRemoveUserFromRoletype(
    params: {
      id: number;
      body: WorkRemoveUserDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.roletypesV2ControllerRemoveUserFromRoletype$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerAddPermissionToRoletype()` */
  static readonly RoletypesV2ControllerAddPermissionToRoletypePath = '/v2/roletypes/{id}/permissions';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerAddPermissionToRoletype()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerAddPermissionToRoletype$Response(
    params: {
      id: number;
      body: WorkAddPermissionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerAddPermissionToRoletypePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerAddPermissionToRoletype$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerAddPermissionToRoletype(
    params: {
      id: number;
      body: WorkAddPermissionDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.roletypesV2ControllerAddPermissionToRoletype$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `roletypesV2ControllerRemovePermissionFromRoletype()` */
  static readonly RoletypesV2ControllerRemovePermissionFromRoletypePath = '/v2/roletypes/{id}/permissions';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV2ControllerRemovePermissionFromRoletype()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerRemovePermissionFromRoletype$Response(
    params: {
      id: number;
      body: WorkRemovePermissionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesV2Service.RoletypesV2ControllerRemovePermissionFromRoletypePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV2ControllerRemovePermissionFromRoletype$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roletypesV2ControllerRemovePermissionFromRoletype(
    params: {
      id: number;
      body: WorkRemovePermissionDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.roletypesV2ControllerRemovePermissionFromRoletype$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
